import { enableProdMode, APP_INITIALIZER, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { addIcons } from 'ionicons';
import {
  addCircleOutline, addOutline, alertCircle, alertCircleOutline, analyticsOutline,
  arrowBackOutline, arrowForwardOutline, attachOutline, businessOutline,
  calendarClearOutline, calendarOutline, cardOutline, caretBackOutline, caretForwardOutline,
  checkmarkCircle, checkmarkCircleOutline, checkmarkDoneOutline,
  chevronDown, chevronForwardOutline, clipboardOutline,
  close, closeCircle, closeCircleOutline, cloudOfflineOutline, copyOutline,
  createOutline, documentAttachOutline, documentOutline, documentTextOutline,
  downloadOutline, eyeOffOutline, eyeOutline, filterOutline, fingerPrintOutline, flashOutline,
  folderOpenOutline, folderOutline, chevronForward,
  helpCircleOutline, homeOutline, hourglassOutline,
  informationCircle, informationCircleOutline, keyOutline, layersOutline,
  lockOpenOutline, logInOutline, logOutOutline, mailOutline,
  peopleCircleOutline, peopleOutline, personCircle, personCircleOutline, personOutline,
  phonePortraitOutline, pricetagOutline, qrCodeOutline,
  refreshOutline, reloadOutline, removeOutline, restaurantOutline, ribbonOutline,
  sadOutline, schoolOutline, search, searchOutline, sendOutline,
  shieldCheckmarkOutline, swapHorizontalOutline, textOutline, timeOutline,
  trashOutline, trendingUpOutline, walletOutline, warning, warningOutline
} from 'ionicons/icons';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { LocalStorageService } from './app/services/local-storage.service';
import { JsBridgeService } from './app/services/js-bridge.service';
import { AppInitService } from './app/services/app-init.service';
import { RefreshTokenInterceptor } from './app/interceptors/refresh-token.interceptor';
import { ApiModule, Configuration } from './api-clients/generated/services';

addIcons({
  addCircleOutline, addOutline, alertCircle, alertCircleOutline, analyticsOutline,
  arrowBackOutline, arrowForwardOutline, attachOutline, businessOutline,
  calendarClearOutline, calendarOutline, cardOutline, caretBackOutline, caretForwardOutline,
  checkmarkCircle, checkmarkCircleOutline, checkmarkDoneOutline,
  chevronDown, chevronForwardOutline, clipboardOutline,
  close, closeCircle, closeCircleOutline, cloudOfflineOutline, copyOutline,
  createOutline, documentAttachOutline, documentOutline, documentTextOutline,
  downloadOutline, eyeOffOutline, eyeOutline, filterOutline, fingerPrintOutline, flashOutline,
  folderOpenOutline, folderOutline, chevronForward,
  helpCircleOutline, homeOutline, hourglassOutline,
  informationCircle, informationCircleOutline, keyOutline, layersOutline,
  lockOpenOutline, logInOutline, logOutOutline, mailOutline,
  peopleCircleOutline, peopleOutline, personCircle, personCircleOutline, personOutline,
  phonePortraitOutline, pricetagOutline, qrCodeOutline,
  refreshOutline, reloadOutline, removeOutline, restaurantOutline, ribbonOutline,
  sadOutline, schoolOutline, search, searchOutline, sendOutline,
  shieldCheckmarkOutline, swapHorizontalOutline, textOutline, timeOutline,
  trashOutline, trendingUpOutline, walletOutline, warning, warningOutline
});

if (environment.production) {
  enableProdMode();
}

(window as any).__MENSA_PRODUCTION__ = environment.production;

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideIonicAngular({
      mode: 'ios',
      animated: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(ApiModule),
    JsBridgeService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: Configuration,
      useFactory: (localStorageService: LocalStorageService) => {
        return new Configuration({
          basePath: environment.servicesUrl,
          accessToken: () => {
            return localStorageService.getAccessToken()!;
          },
        });
      },
      deps: [LocalStorageService], multi: false
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () => appInitService.init(),
      deps: [AppInitService],
      multi: true
    },
  ]
}).catch(err => console.log(err));
